// src/components/AuthCard.tsx
import React, { useState } from 'react';
import { API_BASE } from '../utils/env';
import { useNavigate } from 'react-router-dom';
import { setToken } from '../utils/token';
import { useTelegramWebApp } from '../hooks/useTelegramWebApp';
/* ---------------- иконки ---------------- */
const IconEmail = () => (
  <svg width="33" height="26" viewBox="0 0 33 26" fill="none" xmlns="http://www.w3.org/2000/svg ">
    <path d="M32.7436 3.53847C32.7436 1.78975 31.3128 0.358978 29.5641 0.358978H4.12822C2.3795 0.358978 0.94873 1.78975 0.94873 3.53847V22.6154C0.94873 24.3641 2.3795 25.7949 4.12822 25.7949H29.5641C31.3128 25.7949 32.7436 24.3641 32.7436 22.6154V3.53847ZM29.5641 3.53847L16.8462 11.4872L4.12822 3.53847H29.5641ZM29.5641 22.6154H4.12822V6.71795L16.8462 14.6667L29.5641 6.71795V22.6154Z" fill="white" fillOpacity="0.8"/>
  </svg>
);

const IconKey = () => (
  <svg width="36" height="19" viewBox="0 0 36 19" fill="none" xmlns="http://www.w3.org/2000/svg ">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.10791 9.57731C0.107746 7.50036 0.799588 5.48254 2.07414 3.84265C3.3487 2.20275 5.1333 1.03426 7.14603 0.521754C9.15877 0.00925277 11.2849 0.181964 13.1885 1.0126C15.0921 1.84324 16.6647 3.28445 17.6579 5.10856H32.2017C33.7714 5.10856 35.0454 6.38256 35.0454 7.95231V12.0148C35.0454 12.338 34.917 12.648 34.6884 12.8766C34.4599 13.1052 34.1499 13.2336 33.8267 13.2336H30.1704V16.0773C30.1704 16.4005 30.042 16.7105 29.8134 16.9391C29.5849 17.1677 29.2749 17.2961 28.9517 17.2961H24.8892C24.5659 17.2961 24.2559 17.1677 24.0274 16.9391C23.7988 16.7105 23.6704 16.4005 23.6704 16.0773V13.2336H18.0528C17.2094 15.2159 15.7071 16.846 13.8001 17.848C11.8931 18.85 9.6984 19.1624 7.58751 18.7323C5.47662 18.3022 3.57914 17.156 2.21616 15.4878C0.853191 13.8195 0.108429 11.7316 0.10791 9.57731ZM9.45166 6.32731C8.58971 6.32731 7.76306 6.66972 7.15356 7.27922C6.54407 7.88871 6.20166 8.71536 6.20166 9.57731C6.20166 10.4393 6.54407 11.2659 7.15356 11.8754C7.76306 12.4849 8.58971 12.8273 9.45166 12.8273C10.3136 12.8273 11.1403 12.4849 11.7498 11.8754C12.3592 11.2659 12.7017 10.4393 12.7017 9.57731C12.7017 8.71536 12.3592 7.88871 11.7498 7.27922C11.1403 6.66972 10.3136 6.32731 9.45166 6.32731Z" fill="white" fillOpacity="0.8"/>
  </svg>
);

const IconEye = ({ open = true }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    {open ? (
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12c-2.48 0-4.5-2.02-4.5-4.5S9.52 7.5 12 7.5s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5zm0-7c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5z" fill="rgba(255,255,255,.8)"/>
    ) : (
      <>
        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12c-2.48 0-4.5-2.02-4.5-4.5S9.52 7.5 12 7.5s4.5 2.02 4.5 4.5-2.02 4.5-4.5 4.5zm0-7c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5z" fill="rgba(255,255,255,.8)"/>
        <line x1="3" y1="21" x2="21" y2="3" stroke="rgba(255,255,255,.8)" strokeWidth="2"/>
      </>
    )}
  </svg>
);


/* ---------- типы ---------- */
type Props = {
  initialMode: 'login' | 'signup';
  onClose: () => void;
};

/* ---------- компонент ---------- */
export const AuthCard: React.FC<Props> = ({ initialMode, onClose }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isSignUp, setIsSignUp] = useState(initialMode === 'signup');
  const [toast, setToast] = useState<{ show: boolean; text: string }>({ show: false, text: '' });
  /* поля ввода */
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const { user } = useTelegramWebApp();
  /* показ пароля */
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  /* отправка */
  const handleSubmit = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showToast('Please enter a valid email address');
      return;
    }

    if (isSignUp && password !== confirm) {
      showToast('Passwords do not match');
      return;
    }

    const payload = { email, password, ...(isSignUp && { confirm })};
    try {
      const res = await fetch(
        isSignUp ? `${API_BASE}/signup` : `${API_BASE}/login`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          
        }
      );

      let data: any;
      try {
        data = await res.json();
      } catch {
        data = {};
      }

      if (!res.ok) {
        const errorMessage = data.message || `Server error: ${res.status} ${res.statusText}`;
        throw new Error(errorMessage);
      }
      if (data.access_token) {
        setToken(data.access_token, email);
      }

      showToast('Success! Redirecting...');
      setTimeout(() => onClose(), 1500);
      navigate('/offer');

    } catch (e: any) {
      showToast(e.message);
    } finally {
      setLoading(false); // ← убираем спиннер
  }
  };

  const showToast = (text: string) => {
    setToast({ show: true, text });
    setTimeout(() => setToast({ show: false, text: '' }), 3000);
  };

  /* ---------- стили ---------- */
  const card: React.CSSProperties = {
    position: 'relative',
    width: 511,
    height: isSignUp ? 700 : 700,
    background: 'linear-gradient(90deg, rgba(109,29,125,.2) 0%, rgba(95,11,232,.2) 100%)',
    mixBlendMode: 'normal',
    boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
                -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
                inset 2.72256px 2.53738px 11.72px rgba(255,255,255,.15),
                inset 1.79336px 1.67138px 5.86px rgba(255,255,255,.15)`,
    backdropFilter: 'blur(18.74px)',
    borderRadius: 50,
    margin: '0 auto',
    overflow: 'hidden',
    opacity: 0,
    transform: 'translateY(30px)',
    animation: 'fadeIn .8s forwards',
    transition: 'height .4s',
  };

  const title: React.CSSProperties = {
    position: 'absolute',
    width: 408,
    height: 76,
    left: 120,
    top: 36,
    fontFamily: `'SF Pro', sans-serif`,
    fontWeight: 510,
    fontSize: 64,
    lineHeight: '76px',
    color: '#fff',
  };

  const subtitle: React.CSSProperties = {
    position: 'absolute',
    width: 250,
    height: 19,
    left: 153,
    top: 110,
    fontFamily: `'SF Pro', sans-serif`,
    fontWeight: 510,
    fontSize: 16,
    lineHeight: '19px',
    color: 'rgba(255,255,255,.6)',
  };

  const switcher: React.CSSProperties = {
    position: 'absolute',
    width: 416,
    height: 58,
    left: 48,
    top: 145,
    display: 'flex',
    borderRadius: 28.864,
    overflow: 'hidden',
    background: 'rgba(99,48,193,.3)',
    boxShadow: `-7.84988px -7.31597px 33.792px -8.448px rgba(0,0,0,.15),
                -1.30831px -1.21933px 8.448px -5.632px rgba(0,0,0,.15),
                inset 1.30831px 1.21933px 5.632px rgba(255,255,255,.15),
                inset .654157px .609664px 2.816px rgba(255,255,255,.15)`,
    backdropFilter: 'blur(1.408px)',
  };

  const inputBg: React.CSSProperties = {
    position: 'absolute',
    width: 416,
    height: 58,
    left: 0,
    top: 40,
    background: 'rgba(99,48,193,.2)',
    backgroundBlendMode: 'plus-lighter',
    mixBlendMode: 'normal',
    boxShadow: `-11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
                -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
                inset 2.58318px 2.40748px 11.12px rgba(255,255,255,.15),
                inset 1.65398px 1.54148px 5.56px rgba(255,255,255,.15)`,
    backdropFilter: 'blur(16.04px)',
    borderRadius: 28.864,
  };

  const label: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    fontFamily: `'SF Pro', sans-serif`,
    fontWeight: 510,
    fontSize: 20,
    lineHeight: '24px',
    color: 'rgba(255,255,255,.8)',
  };

  const inputStyle: React.CSSProperties = {
    position: 'absolute',
    left: 75,
    top: 55,
    width: 300,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    fontFamily: `'SF Pro', sans-serif`,
    fontWeight: 510,
    fontSize: 24,
    lineHeight: '29px',
    color: '#fff',
  };
  const inputStyle2: React.CSSProperties = {
    position: 'absolute',
    left: 75,
    top: 55,
    width: 300,
    background: 'transparent',
    border: 'none',
    outline: 'none',
    fontFamily: `'SF Pro', sans-serif`,
    fontWeight: 510,
    fontSize: 24,
    lineHeight: '29px',
    color: '#fff',
  };

  const btnGrad: React.CSSProperties = {
    position: 'absolute',
    width: 415,
    height: 58,
    left: 52,
    top: isSignUp ? 600 : 600,
    background: 'linear-gradient(90deg, rgba(109,29,125,.8) 0%, rgba(95,11,232,.8) 100%)',
    mixBlendMode: 'normal',
    boxShadow: `-7.84988px -7.31597px 33.792px -8.448px rgba(0,0,0,.15),
                -1.30831px -1.21933px 8.448px -5.632px rgba(0,0,0,.15),
                inset 1.30831px 1.21933px 5.632px rgba(255,255,255,.15),
                inset .654157px .609664px 2.816px rgba(255,255,255,.15)`,
    backdropFilter: 'blur(1.408px)',
    borderRadius: 28.864,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform .2s',
  };

  const closeCross: React.CSSProperties = {
    position: 'absolute',
    right: 28,
    top: 28,
    width: 24,
    height: 24,
    cursor: 'pointer',
    zIndex: 10,
  };

  /* ---------- блоки с pointerEvents ---------- */
  const loginBlock: React.CSSProperties = {
    position: 'absolute',
    left: 51,
    width: 416,
    height: 98,
    transition: 'max-height .4s, opacity .4s',
    maxHeight: !isSignUp ? 98 : 0,
    opacity: !isSignUp ? 1 : 0,
    overflow: 'hidden',
    top: 225,
    pointerEvents: !isSignUp ? 'auto' : 'none',
  };

  const loginBlockPass: React.CSSProperties = {
    ...loginBlock,
    top: 351,
  };

  const inputBlock: React.CSSProperties = {
    position: 'absolute',
    left: 51,
    width: 416,
    height: 98,
    transition: 'max-height .4s, opacity .4s',
    maxHeight: isSignUp ? 98 : 0,
    opacity: isSignUp ? 1 : 0,
    overflow: 'hidden',
  };

  return (
    <div style={card}>
      <style>{`
        @keyframes fadeIn {
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeOut {
          to { opacity: 0; transform: translateY(-10px); }
        }
      `}</style>

      <svg style={closeCross} onClick={onClose} viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="#fff" strokeWidth={2} strokeLinecap="round"/>
      </svg>

      <div style={title}>{isSignUp ? 'Welcome' : 'Welcome'}</div>
      <div style={subtitle}>
        {isSignUp
          ? 'Hi, you need to register to enter'
          : 'Hi, you need to login to enter'}
      </div>

      <div style={switcher}>
        <button
          onClick={() => setIsSignUp(false)}
          style={{
            flex: 1,
            border: 'none',
            background: isSignUp ? 'transparent' : 'rgba(99,48,193,.8)',
            borderRadius: 28.864,
            fontFamily: `'SF Pro', sans-serif`,
            fontWeight: 510,
            fontSize: 33.792,
            color: '#fff',
            cursor: 'pointer',
            transition: 'background .35s',
            zIndex: 200,
          }}
        >
          Login
        </button>
        <button
          onClick={() => setIsSignUp(true)}
          style={{
            flex: 1,
            border: 'none',
            background: isSignUp ? 'rgba(99,48,193,.8)' : 'transparent',
            borderRadius: 28.864,
            fontFamily: `'SF Pro', sans-serif`,
            fontWeight: 510,
            fontSize: 33.792,
            color: '#fff',
            cursor: 'pointer',
            transition: 'background .35s',
          }}
        >
          Sign Up
        </button>
      </div>

      {/* ============== Login-поля ============== */}
      <div style={loginBlock}>
        <div style={label}>Email Address</div>
        <div style={inputBg} />
        <div style={{ position: 'absolute', left: 20, top: 56 }}>
          <IconEmail />
        </div>
        <input
          style={inputStyle2}
          placeholder="John123@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div style={loginBlockPass}>
        <div style={label}>Password</div>
        <div style={inputBg} />
        <div style={{ position: 'absolute', left: 20, top: 58 }}>
          <IconKey />
        </div>
        <input
          style={inputStyle}
          type={showPass ? 'text' : 'password'}
          placeholder="···············"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div
          style={{
            position: 'absolute',
            left: 362,
            top: 56,
            cursor: 'pointer',
          }}
          onClick={() => setShowPass((s) => !s)}
        >
          <IconEye open={showPass} />
        </div>
      </div>

      {/* ============== SignUp-поля ============== */}
      <div style={{ ...inputBlock, top: 225 }}>
        <div style={label}>Email Address</div>
        <div style={inputBg} />
        <div style={{ position: 'absolute', left: 20, top: 56 }}>
          <IconEmail />
        </div>
        <input
          style={inputStyle2}
          placeholder="John123@gmail.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div style={{ ...inputBlock, top: 350 }}>
        <div style={label}>Create Password</div>
        <div style={inputBg} />
        <div style={{ position: 'absolute', left: 20, top: 58 }}>
          <IconKey />
        </div>
        <input
          style={inputStyle}
          type={showPass ? 'text' : 'password'}
          placeholder="···············"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div
          style={{
            position: 'absolute',
            left: 362,
            top: 56,
            cursor: 'pointer',
          }}
          onClick={() => setShowPass((s) => !s)}
        >
          <IconEye open={showPass} />
        </div>
      </div>

      <div style={{ ...inputBlock, top: 475 }}>
        <div style={label}>Confirm Password</div>
        <div style={inputBg} />
        <div style={{ position: 'absolute', left: 20, top: 58 }}>
          <IconKey />
        </div>
        <input
          style={inputStyle}
          type={showConfirm ? 'text' : 'password'}
          placeholder="···············"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        <div
          style={{
            position: 'absolute',
            left: 362,
            top: 56,
            cursor: 'pointer',
          }}
          onClick={() => setShowConfirm((s) => !s)}
        >
          <IconEye open={showConfirm} />
        </div>
      </div>

      {/* ============== кнопка ============== */}
      <div
        style={btnGrad}
        onClick={handleSubmit}
        onMouseDown={(e) => (e.currentTarget.style.transform = 'scale(.96)')}
        onMouseUp={(e) => (e.currentTarget.style.transform = 'scale(1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        <div style={{ fontFamily: `'SF Pro', sans-serif`, fontWeight: 510, fontSize: 33.792, color: '#fff' }}>
          {isSignUp ? 'Sign Up' : 'Login'}
        </div>
      </div>
      {loading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 58 }}>
          <div style={{ width: 24, height: 24, border: '3px solid rgba(255,255,255,.2)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
        </div>
      ) : (
        <div style={btnGrad} onClick={handleSubmit}> ... </div>
      )}
      {/* ============== тост уведомление ============== */}
      {toast.show && (
        <div
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            background: 'rgba(255,80,80,.9)',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: 8,
            fontFamily: `'SF Pro', sans-serif`,
            fontSize: 16,
            zIndex: 100,
            animation: 'fadeIn .3s, fadeOut .3s 2.5s forwards',
          }}
        >
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          {toast.text}
        </div>
      )}
    </div>
  );
};